import constants from '../constants';
import { FILTER_NAVIGATION_ACTIONS } from '../store/filterNavigation/name';

import store from '@/store/index';

const { MPK_PROJECT_ROUTE_PATHS } = constants;

const MPK_FILTER_PATHS = new Set(Object.values(MPK_PROJECT_ROUTE_PATHS));

export const registerGuards = (router) => {
  router.beforeEach((to, from) => {
    if (MPK_FILTER_PATHS.has(to.path) && to.path !== from.path) {
      return store.dispatch(FILTER_NAVIGATION_ACTIONS.onNavigation, { toPath: to.path, fromPath: from.path });
    }
  });
};

export const routes = [
  {
    path: MPK_PROJECT_ROUTE_PATHS.LIST,
    name: 'Projects',
    component: () => import('../views/Projects.vue'),
    props: true,
  },
  {
    path: MPK_PROJECT_ROUTE_PATHS.MAP,
    name: 'ProjectsMap',
    component: () => import('../views/ProjectsMap.vue'),
  },
  {
    path: MPK_PROJECT_ROUTE_PATHS.STATISTICS,
    name: 'ProjectsStatistics',
    component: () => import('../views/ProjectsStatistics.vue'),
  },
  {
    path: '/mpkProjects/edit/:id',
    name: 'EditProjectCard',
    component: () => import('../views/EditProjectCard.vue'),
  },
  {
    path: '/mpkProjects/view/:id',
    name: 'ProjectCard',
    component: () => import('../views/ProjectCard.vue'),
  },
];
